(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rjkl-bildstrecke"] && !Shopify.designMode) return;
  try {
    const RJKL_ZEICHEN = {
    zu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    zurueck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    vor: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
  };

  class RjklBildstrecke extends HTMLElement {
    connectedCallback() {
      if (this.dataset.vergroessern !== 'an') return;

      this.rahmen = Array.from(this.querySelectorAll('.rjkl-bild__rahmen[data-gross]'));
      if (this.rahmen.length === 0) return;

      this.rahmen.forEach((rahmen, nummer) => this.knopfEinsetzen(rahmen, nummer));
      this.kastenBauen();
    }

    disconnectedCallback() {
      this.kasten?.remove();
      document.documentElement.style.overflow = '';
    }

    // Ein echter <button> statt eines klickbaren <div>: nur so ist das Foto
    // mit der Tastatur erreichbar und wird von Vorlesesoftware angesagt.
    knopfEinsetzen(rahmen, nummer) {
      if (rahmen.querySelector('.rjkl-bild__lupe')) return;

      const beschreibung = rahmen.dataset.text || rahmen.dataset.alt || '';
      const knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'rjkl-bild__lupe';
      knopf.setAttribute('aria-label', beschreibung ? `Bild vergrößern: ${beschreibung}` : 'Bild vergrößern');
      knopf.addEventListener('click', () => this.oeffne(nummer));
      rahmen.appendChild(knopf);
    }

    kastenBauen() {
      const mehrere = this.rahmen.length > 1;

      this.kasten = document.createElement('dialog');
      this.kasten.className = 'rjkl-leuchtkasten';
      this.kasten.innerHTML = `
        <figure class="rjkl-leuchtkasten__inhalt">
          <img class="rjkl-leuchtkasten__bild" alt="">
          <figcaption class="rjkl-leuchtkasten__text"></figcaption>
        </figure>
        <button type="button" class="rjkl-leuchtkasten__knopf rjkl-leuchtkasten__knopf--zu" aria-label="Schließen">${RJKL_ZEICHEN.zu}</button>
        ${
          mehrere
            ? `<button type="button" class="rjkl-leuchtkasten__knopf rjkl-leuchtkasten__knopf--zurueck" aria-label="Vorheriges Bild">${RJKL_ZEICHEN.zurueck}</button>
               <button type="button" class="rjkl-leuchtkasten__knopf rjkl-leuchtkasten__knopf--vor" aria-label="Nächstes Bild">${RJKL_ZEICHEN.vor}</button>`
            : ''
        }
      `;
      this.appendChild(this.kasten);

      this.bild = this.kasten.querySelector('.rjkl-leuchtkasten__bild');
      this.text = this.kasten.querySelector('.rjkl-leuchtkasten__text');

      this.kasten.querySelector('.rjkl-leuchtkasten__knopf--zu').addEventListener('click', () => this.kasten.close());
      this.kasten.querySelector('.rjkl-leuchtkasten__knopf--zurueck')?.addEventListener('click', () => this.blaettere(-1));
      this.kasten.querySelector('.rjkl-leuchtkasten__knopf--vor')?.addEventListener('click', () => this.blaettere(1));

      // Ein Klick daneben trifft den Dialog selbst — alles darin hat ein
      // eigenes Ziel. Das ist die Geste, die Besucher von jedem Bildbetrachter
      // kennen.
      this.kasten.addEventListener('click', (ereignis) => {
        if (ereignis.target === this.kasten) this.kasten.close();
      });

      this.kasten.addEventListener('keydown', (ereignis) => {
        if (ereignis.key === 'ArrowLeft') this.blaettere(-1);
        if (ereignis.key === 'ArrowRight') this.blaettere(1);
      });

      // Escape schliesst den Dialog am Skript vorbei, deshalb haengt das
      // Aufraeumen am close-Ereignis und nicht am Schliess-Knopf.
      this.kasten.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        this.rahmen[this.nummer]?.querySelector('.rjkl-bild__lupe')?.focus();
      });
    }

    oeffne(nummer) {
      this.zeige(nummer);
      document.documentElement.style.overflow = 'hidden';
      this.kasten.showModal();
    }

    blaettere(richtung) {
      const anzahl = this.rahmen.length;
      this.zeige((this.nummer + richtung + anzahl) % anzahl);
    }

    zeige(nummer) {
      const rahmen = this.rahmen[nummer];
      if (!rahmen) return;

      this.nummer = nummer;
      this.bild.src = rahmen.dataset.gross;
      this.bild.alt = rahmen.dataset.alt || '';
      // Aus dem Verhaeltnis rechnet das Stylesheet Breite und Hoehe des
      // Kastens — noch bevor das Foto geladen ist.
      this.kasten.style.setProperty('--rjkl-leuchtkasten-verhaeltnis', rahmen.dataset.verhaeltnis || '1.5');
      this.text.textContent = rahmen.dataset.text || '';
    }
  }

  if (!customElements.get('rjkl-bildstrecke')) {
    customElements.define('rjkl-bildstrecke', RjklBildstrecke);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rjkl-lieferhinweis"] && !Shopify.designMode) return;
  try {
    class RjklLieferhinweis extends HTMLElement {
    connectedCallback() {
      // Das Ereignis steigt bis zur Sektion auf, nicht bis zum Dokument —
      // deshalb wird dort gelauscht und nicht an window.
      this.abschnitt = this.closest('.shopify-section, dialog');
      this.abschnitt?.addEventListener('variant:update', this.aktualisiere);
    }

    disconnectedCallback() {
      this.abschnitt?.removeEventListener('variant:update', this.aktualisiere);
    }

    aktualisiere = (ereignis) => {
      const neueSeite = ereignis.detail?.data?.html;
      if (!neueSeite) return;

      const neu = neueSeite.querySelector('rjkl-lieferhinweis');
      // Kein Treffer heisst: Die neue Variante zeigt hier gar nichts an.
      // Dann bleibt der alte Hinweis stehen statt zu verschwinden — das
      // waere ein springendes Layout ohne Gewinn.
      if (neu) this.innerHTML = neu.innerHTML;
    };
  }

  if (!customElements.get('rjkl-lieferhinweis')) {
    customElements.define('rjkl-lieferhinweis', RjklLieferhinweis);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rjkl-preishinweis"] && !Shopify.designMode) return;
  try {
    // Beim Formatwechsel holt Horizon die Seite im Hintergrund neu und meldet
  // das per "variant:update". Ohne dieses Skript bliebe der Satz des zuvor
  // gewaehlten Formats stehen — beim Sprung Buch -> eBook also ausgerechnet
  // der Versandhinweis.
  class RjklPreishinweis extends HTMLElement {
    connectedCallback() {
      this.abschnitt = this.closest('.shopify-section, dialog');
      this.abschnitt?.addEventListener('variant:update', this.aktualisiere);
    }

    disconnectedCallback() {
      this.abschnitt?.removeEventListener('variant:update', this.aktualisiere);
    }

    aktualisiere = (ereignis) => {
      const neueSeite = ereignis.detail?.data?.html;
      if (!neueSeite) return;
      const neu = neueSeite.querySelector('rjkl-preishinweis');
      if (neu) this.innerHTML = neu.innerHTML;
    };
  }

  if (!customElements.get('rjkl-preishinweis')) {
    customElements.define('rjkl-preishinweis', RjklPreishinweis);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rjkl-widerruf"] && !Shopify.designMode) return;
  try {
    class RjklWiderruf extends HTMLElement {
    connectedCallback() {
      this.endpunkt = this.dataset.endpunkt;
      this.formular = this.querySelector('form');
      if (!this.endpunkt || !this.formular) return;

      this.schritt2 = this.querySelector('[data-schritt="2"]');
      this.fertig = this.querySelector('[data-schritt="fertig"]');
      this.knopf = this.querySelector('[data-bestaetigen]');

      // Erst wenn der Nonce da ist, uebernimmt das Skript. Scheitert der Abruf,
      // bleibt der serverseitige Weg stehen und das Formular postet normal.
      this.nonceHolen();
    }

    async nonceHolen() {
      try {
        const antwort = await fetch(this.endpunkt + '?aktion=nonce', { mode: 'cors' });
        const daten = await antwort.json();
        if (!daten.nonce) return;
        this.nonce = daten.nonce;
        this.uebernehmen();
      } catch (fehler) {
        /* Absicht: ohne Nonce kein JS-Weg. */
      }
    }

    uebernehmen() {
      this.formular.addEventListener('submit', (ereignis) => {
        ereignis.preventDefault();
        this.zeigeZusammenfassung();
      });
      this.knopf?.addEventListener('click', () => this.absenden());
      this.querySelector('[data-zurueck]')?.addEventListener('click', () => {
        this.schritt2.hidden = true;
        this.formular.hidden = false;
        this.formular.querySelector('input[name="name"]')?.focus();
      });
    }

    werte() {
      const lies = (feld) => this.formular.querySelector(`[name="${feld}"]`).value.trim();
      return {
        name: lies('name'),
        bestellnummer: lies('bestellnummer'),
        email: lies('email'),
        webseite: lies('webseite'),
      };
    }

    zeigeZusammenfassung() {
      const werte = this.werte();
      // textContent, nicht innerHTML — die Werte kommen vom Besucher.
      this.querySelectorAll('[data-wert]').forEach((stelle) => {
        stelle.textContent = werte[stelle.dataset.wert] || '';
      });
      this.meldungWeg();
      this.formular.hidden = true;
      this.schritt2.hidden = false;
      this.schritt2.querySelector('.rjkl-widerruf__titel')?.focus();
    }

    async absenden() {
      const werte = this.werte();
      this.knopf.disabled = true;
      this.knopf.textContent = 'Wird gesendet …';

      try {
        const antwort = await fetch(this.endpunkt, {
          method: 'POST',
          mode: 'cors',
          body: new URLSearchParams({
            aktion: 'absenden',
            format: 'json',
            nonce: this.nonce,
            ...werte,
          }),
        });
        const daten = await antwort.json();

        if (daten.ok) {
          this.zeigeBestaetigung(daten.zeitpunkt, werte.email);
          return;
        }
        this.zeigeFehler(daten);
      } catch (fehler) {
        this.meldung(
          this.schritt2,
          'Die Verbindung hat nicht geklappt. Bitte versuche es gleich noch einmal — '
            + 'oder schick uns den Widerruf formlos per E-Mail, das ist genauso wirksam.'
        );
      }

      this.knopf.disabled = false;
      this.knopf.textContent = 'Widerruf bestätigen';
    }

    zeigeFehler(daten) {
      if (daten.grund === 'eingabe') {
        this.schritt2.hidden = true;
        this.formular.hidden = false;
        Object.entries(daten.fehler || {}).forEach(([feld, text]) => {
          const stelle = this.formular.querySelector(`[data-fehler="${feld}"]`);
          if (stelle) {
            stelle.textContent = text;
            stelle.hidden = false;
          }
        });
        this.formular.querySelector('input[name="name"]')?.focus();
        return;
      }

      const texte = {
        nonce: 'Das Formular ist nicht mehr gültig. Bitte lade die Seite neu und versuche es noch einmal.',
        rate: 'Von diesem Anschluss kamen in kurzer Zeit mehrere Widerrufe. Bitte versuche es später '
          + 'noch einmal oder schreib uns direkt eine E-Mail.',
      };
      this.meldung(
        this.schritt2,
        texte[daten.grund] || daten.meldung || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.'
      );
    }

    zeigeBestaetigung(zeitpunkt, email) {
      this.fertig.querySelector('[data-zeitpunkt]').textContent = zeitpunkt || '';
      this.fertig.querySelector('[data-wert="email"]').textContent = email;
      this.formular.hidden = true;
      this.schritt2.hidden = true;
      this.fertig.hidden = false;
      this.fertig.querySelector('.rjkl-widerruf__titel')?.focus();
    }

    meldung(bereich, text) {
      const stelle = bereich.querySelector('[data-meldung]');
      if (!stelle) return;
      stelle.textContent = text;
      stelle.hidden = false;
    }

    meldungWeg() {
      this.querySelectorAll('[data-meldung]').forEach((stelle) => {
        stelle.hidden = true;
        stelle.textContent = '';
      });
      this.querySelectorAll('[data-fehler]').forEach((stelle) => {
        stelle.hidden = true;
        stelle.textContent = '';
      });
    }
  }

  if (!customElements.get('rjkl-widerruf')) {
    customElements.define('rjkl-widerruf', RjklWiderruf);
  }
  } catch(e) { console.error(e); }
})();

})();
